<template>
    <div class="betslip__bonus">
        <div class="betslip__bonus__percentage">
            <span class="betslip__bonus__percentage__label">{{ $t('potential bonus') | capitalize }}:</span>
            <Tooltip :text="$t('It applies for minimum of 6 events with a minimum quota of 1.25')">
                <span
                    v-if="bonusPercentage"
                    class="betslip__bonus__percentage__amount"
                >
                    {{ bonusPercentage | twoDecimals }} %
                </span>
            </Tooltip>
        </div>
        <div class="betslip__bonus__amount">
            <span class="amount">{{ bonusAmount | currency }}</span>
            <span class="currency">{{ $t('currencyAbbreviation') }}</span>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            bonusAmount: {
                type: Number,
                required: true,
            },
            bonusPercentage: {
                type: Number,
                required: true,
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/app/modules/shared/betSlip/BetSlipBonus.vue